import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserStoreService } from 'src/app/services/user-store.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  user = '';
  email = '';
  showSearch = false;
  isCvDetailRoute: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private oauthService: OAuthService,
    private userStore: UserStoreService,
    private router: Router,
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.isCvDetailRoute = this.router.url.includes('cv-detail'));
  }

  ngOnInit(): void {
    this.userStore.user.subscribe((user) => {
      if (user.firstName != null || user.lastName != null) {
        this.user = user.firstName + " " + user.lastName;
      }
      this.email = user.email;
      this.showSearch = user.businessAdmin;
    });
  }

  logout() {
    this.oauthService.logOut();
  }
}
